import bbb from "@/assets/badge-bbb.png";
import showcase from "@/assets/badge-showcase.png";
import angies from "@/assets/badge-angies.png";

const badges = [
  { src: bbb, alt: "BBB Accredited Business — A+ Rating" },
  { src: showcase, alt: "Tile featured in Parade of Homes projects" },
  { src: angies, alt: "Angie's List Super Service Award" },
];

export function Awards() {
  return (
    <section id="awards" className="py-20 md:py-28 bg-background border-y border-border">
      <div className="container-prose">
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-14 items-center">
          <div>
            <span className="eyebrow">Awards & Recognition</span>
            <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">
              A reputation built on a quarter-century of trust.
            </h2>
            <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
              RKD Tile holds an <strong className="text-foreground">A+ rating with the Better Business Bureau</strong> and has received the
              <strong className="text-foreground"> Park City Builder's Choice Award three times</strong>. Our tile work has been installed in
              <strong className="text-foreground"> multiple Park City Parade of Homes</strong> projects over the years, as well as a featured home in last year's
              <strong className="text-foreground"> Utah County Parade of Homes</strong>.
            </p>
            <p className="mt-4 text-muted-foreground leading-relaxed">
              Licensed and insured, RKD Tile stays on schedule and delivers the highest quality service across the greater Salt Lake City region.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-6">
            {badges.map((b) => (
              <div key={b.alt} className="bg-cream border border-border p-6 flex items-center justify-center aspect-square">
                <img src={b.src} alt={b.alt} className="max-h-24 w-auto object-contain" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
